<template>
  <div>
    <CargoColegiadoForm :cargoColegiado="null" />
  </div>
</template>

<script>
import CargoColegiadoForm from "../../components/cargo_colegiado/CargoColegiadoForm.vue";

export default {
  name: "CargoColegiadoNew",
  components: {
    CargoColegiadoForm,
  },
};
</script>

<style lang="scss" scoped></style>